import React from 'react';
import { Eye, Edit, Gift, BookOpen, Crown, Calendar, ShieldOff, Trash2 } from 'lucide-react';

const ActionButtons = ({ 
  user, 
  onView, 
  onEdit, 
  onGift, 
  onAccess, 
  onSubscribe, 
  onRevoke, 
  onDelete 
}) => {
  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => onView(user)}
        className="p-1.5 text-gray-400 hover:text-blue-400 hover:bg-blue-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-blue-700"
        title="Просмотр профиля"
      >
        <Eye className="w-4 h-4" />
      </button>
      <button
        onClick={() => onEdit(user)}
        className="p-1.5 text-gray-400 hover:text-green-400 hover:bg-green-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-green-700"
        title="Редактировать профиль"
      >
        <Edit className="w-4 h-4" />
      </button>
      <button
        onClick={() => onGift(user)}
        className="p-1.5 text-pink-400 hover:text-pink-300 hover:bg-pink-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-pink-700"
        title="Управление подарками"
      >
        <Gift className="w-4 h-4" />
      </button>
      <button
        onClick={() => onAccess(user)}
        className="p-1.5 text-purple-400 hover:text-purple-300 hover:bg-purple-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-purple-700"
        title="Управление доступом к материалам"
      >
        <BookOpen className="w-4 h-4" />
      </button>
      {user.premium ? (
        <>
          <button
            onClick={() => onSubscribe(user, 'extend')}
            className="p-1.5 text-blue-400 hover:text-blue-300 hover:bg-blue-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-blue-700"
            title="Продлить подписку"
          >
            <Calendar className="w-4 h-4" />
          </button>
          <button
            onClick={() => onRevoke(user)}
            className="p-1.5 text-red-400 hover:text-red-300 hover:bg-red-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-red-700"
            title="Отозвать Premium"
          >
            <ShieldOff className="w-4 h-4" />
          </button>
        </>
      ) : (
        <button
          onClick={() => onSubscribe(user, 'grant')}
          className="p-1.5 text-yellow-400 hover:text-yellow-300 hover:bg-yellow-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-yellow-600"
          title="Выдать Premium"
        >
          <Crown className="w-4 h-4" />
        </button>
      )}
      <button
        onClick={() => onDelete(user.id)}
        className="p-1.5 text-gray-400 hover:text-red-400 hover:bg-red-900/30 rounded-lg transition-all duration-200 border border-gray-700 hover:border-red-700"
        title="Удалить пользователя"
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ActionButtons;